import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class LoanRepaymentChequeService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getById(loanAccountId: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `loanrepaymentcheque/${loanAccountId}?isMaintenance=${forMaintenance}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(loanRepaymentCheques: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'loanrepaymentcheque', loanRepaymentCheques).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(loanRepaymentCheques: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + 'loanrepaymentcheque', loanRepaymentCheques).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(loanAccountId: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'loanrepaymentcheque/authorise', loanAccountId).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByDates(fromDate: Date, toDate: Date): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `loanrepaymentcheque/dates/${fromDate}?toDate=${toDate}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
